var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisioncare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H28.4C33.9229 0 38.4 4.47715 38.4 10V28C38.4 33.5228 33.9228 38 28.4 38H9.99999C4.47715 38 0 33.5228 0 28V10Z",
    fill: "#D8EAF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_376_37711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.83325 19C9.83325 19 13.1666 12.3333 18.9999 12.3333C24.8333 12.3333 28.1666 19 28.1666 19C28.1666 19 24.8333 25.6667 18.9999 25.6667C13.1666 25.6667 9.83325 19 9.83325 19Z",
    stroke: "#004276",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 21.5C20.3807 21.5 21.5 20.3807 21.5 19C21.5 17.6193 20.3807 16.5 19 16.5C17.6193 16.5 16.5 17.6193 16.5 19C16.5 20.3807 17.6193 21.5 19 21.5Z",
    stroke: "#004276",
    strokeWidth: 0.833333
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_376_37711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisioncare);
export default __webpack_public_path__ + "static/media/vision care.44e7c441ce5fd21d5732dc2fbfff7c6f.svg";
export { ForwardRef as ReactComponent };